import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CommonModal from './CommonModal.vue';
import CommonButton from '../CommonButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WelcomeModal',
  setup(__props, { expose: __expose }) {

const welcomeModal = ref<InstanceType<typeof CommonModal>>();

__expose({
  open: (params?: {
    zIndex?: number
  }) => {
    welcomeModal.value?.open({
      zIndex: params?.zIndex ?? 10000,
    });
  },
  close: () => {
    welcomeModal.value?.close();
  }
})


const __returned__ = { welcomeModal, CommonModal, CommonButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})